export const black = '#000000';
export const blue = '#338AE6';
export const blue01 = '#3F99F8';
export const blue02 = '#58A9FF';
export const blue03 = '#E3EAF78C';
export const blue04 = '#D0E3E7';
export const blue05 = "#0099FF"
export const blueDark01 = '#00273B';
/** Accordion intro copy / tooltip body (distinct from blueDark01) */
export const blueBody = '#00237B';
export const blueDark02 = '#264758';
export const blueDark03 = '#295972';
export const blueDark04 = '#274757';
export const blueLink = '#134fbd';
export const blueContact = '#134EBD';
export const blueDisabled01 = '#C5E0FD';
export const blueDisabled02 = '#D4E9FE';
export const blueLight = '#09f'
export const teal01 = '#8ebac5';
export const teal05 = '#eff9fc';
export const grayDark01 = '#333333';
export const purpleLight = '#E3EAF7';
export const grayDark02 = '#4D4D4D';
export const grayDark03 = '#666666';
export const grayMuted = '#555555';
export const grayDark05 = '#90908E';
export const grayDark06 = '#C1C1C1';
export const grayDark07 = '#999999';
export const grayDark08 = '#8B9DA7';
export const grayDark09 = '#7D8C94';
export const grayDark10 = '#D9D9D9';
export const grayLight01 = '#D3D3D3';
export const grayLight02 = '#E3E3E3';
export const grayLight03 = '#EDEDED';
export const grayLight04 = '#f2f2f2';
export const grayLight05 = '#FAFAFA';
export const grayLight06 = '#F5F5F5';
export const green = '#3DA100';
export const green01 = '#93C9D9';
export const greenLight = '#37760d';
export const greenDark = '#2d6f01';
export const orange = '#F05508';
export const orange01 = '#F26522';
export const orange02 = '#FF7F37';
export const white = '#ffffff';
export const blackShadow25 = 'rgba(0, 0, 0, 0.25)';
export const impactHumanHealth = '#D7452D';
export const error = '#990000';
export const checkGreen = '#008000';
